import { getEventTracker } from '@libs/eventTracking'
import {
  getCurrentPagePropertyFor,
  getNextPagePropertyFor,
} from '@libs/eventTracking/eventPropertyUtils'

/**
 * [Link to spec](https://www.dropbox.com/scl/fi/rkxbqh1mbv8ao233xg0cd/.paper?dl=0&rlkey=2e0nk761f1ck5vb2hiojc49w0)
 */
export function trackIntersectionDownloadAppEvent(currentPageUrl, slogan, toPageUrl) {
  getEventTracker().track({
    name: 'intersection.download-app',
    properties: {
      currentPage: getCurrentPagePropertyFor(undefined, currentPageUrl),
      toPage: getNextPagePropertyFor({ pageName: undefined, pageUrl: toPageUrl }),
      slogan,
    },
  })
}
